<template>
  <div class="echarts" id="threerighttwo"></div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  inject,
  watchEffect,
  nextTick,
  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import * as echarts from "echarts";
import { eventlist } from "@/api/threeSolid/threeSolidHome.js";
// import { analyseeventregion } from "@/api/dataAnalysis/eventAnalysis.js";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      echartsList: [],
      echartsListName: [],
      echartsListValue: [],
    });
    const refData = toRefs(data);
    const regionInfo = inject("region");
    watchEffect(() => {
      if (regionInfo.regionList) {
        nextTick(() => {
          threerighttwo();
        });
      }
    });
    //排序
    const by = (name) => {
      return function (o, p) {
        let a, b;
        if (typeof o === "object" && typeof p === "object" && o && p) {
          a = o[name];
          b = p[name];
          if (a === b) {
            return 0;
          }
          if (typeof a === typeof b) {
            return a < b ? 1 : -1;
          }
          return typeof a < typeof b ? 1 : -1;
        }
      };
    };
    const numberall = async () => {
      data.echartsListName = [];
      data.echartsListValue = [];

      const param = {
        regionIds: regionInfo.regionList.toString(),
      };
      const res = await eventlist(param);
      data.echartsList = res.data.sort(by("value"));
      data.echartsList.forEach((item, index) => {
        if (index < 6) {
          data.echartsListName.push(item.name);
          data.echartsListValue.push(item.value);
        }
      });
    };
    let mythreerighttwo;
    const threerighttwo = async () => {
      await numberall();
      mythreerighttwo = echarts.init(document.getElementById("threerighttwo"));
      const option = {
        barWidth: 13,
        xAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.2)",
              type: "dashed",
            },
          },
          axisTick: {
            show: true,
          },
          axisLabel: {
            //  改变x轴字体颜色和大小
            textStyle: {
              color: "rgba(250,250,250,0.6)",
              fontSize: 14,
            },
          },
        },
        grid: {
          top: 40,
          left: 80,
          right: 30,
          bottom: 50,
          // containLabel: true
        },
        yAxis: {
          type: "category",
          data: data.echartsListName,
          // data: [
          //   "文峰街道",
          //   "汉丰街道",
          //   "云枫街道",
          //   "镇东街道",
          //   "丰乐街道",
          //   "正安街道",
          // ],
          splitLine: {
            show: false,
          },

          axisLine: {
            //  改变y轴颜色
            lineStyle: {
              color: "#2c4054",
            },
          },
          axisLabel: {
            //  改变y轴字体颜色和大小
            // formatter: '{value} m³ ', //  给y轴添加单位
            textStyle: {
              color: "rgba(250,250,250,0.6)",
              fontSize: 14,
            },
          },
        },
        series: [
          {
            type: "bar",
            name: "产出",
            barGap: "0%",
            barWidth: "30%",
            itemStyle: {
              normal: {
                label: {
                  show: false, // 开启显示
                  position: "insideRight", // 在上方显示
                  textStyle: {
                    // 数值样式
                    color: "#FFFFFF",
                    fontSize: 20,
                    // fontWeight: 600
                  },
                },
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 0,
                    color: "rgba(24,144,255,1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(24,144,255,0)",
                  },
                ]),
                // barBorderRadius: 15
              },
            },
            data: data.echartsListValue,
            // data: [16, 21, 26, 29, 35, 42],
          },
        ],
      };

      //   option && data.myChart.setOption(option);
      //   data.myChart.on('click', function(params) {
      //     context.emit('dialogSate', true); ;
      //   });
      // };
      mythreerighttwo.setOption(option);
    };
    onMounted(() => {
      // threerighttwo();
      window.addEventListener("resize", () => {
        mythreerighttwo.resize();
      });
    });

    return { ...refData };
  },
});
</script>
<style lang="scss" scoped>
#threerighttwo {
  width: 100%;
  height: 90%;
}
</style>
